import ChartsService from '@/services/benchmarks/ChartsService';
import { getBenchmarkId } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchFanbaseEvolutionTable({ commit, rootState, rootGetters }) {
  try {
    commit(chartsMutationTypes.FANBASE_GROWTH_TABLE_LOADING, true);
    commit(chartsMutationTypes.FANBASE_GROWTH_TABLE_ERROR, false);

    const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');
    const handleChannel = rootState.ui.channel === 'Todas' ? {} : { channel: rootState.ui.channel };

    const { data } = await ChartsService.getFanbaseEvolutionTable({
      'benchmark-id': getBenchmarkId(),
      'group-id': groupIdListJoined,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      ...handleChannel,
    });

    if (!Array.isArray(data)) throw new Error();

    const formatedData = data.map(
      ({ average_increase, id, max_increase, max_increase_date, name, total_followers }) => ({
        id,
        value: false,
        name,
        total_followers,
        average_increase,
        max_increase_date,
        max_increase,
      })
    );

    commit(chartsMutationTypes.FANBASE_GROWTH_TABLE_DATA, { data: formatedData });
  } catch (e) {
    commit(chartsMutationTypes.FANBASE_GROWTH_TABLE_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.FANBASE_GROWTH_TABLE_LOADING, false);
  }
}
